import { connect } from "react-redux";
import { getFormValues, reduxForm } from "redux-form";
import React, { Component } from "react";
import Grid from "@react/react-spectrum/Grid/js/Grid";
import GridColumn from "@react/react-spectrum/Grid/js/GridColumn";
import GridRow from "@react/react-spectrum/Grid/js/GridRow";
import Well from "@react/react-spectrum/Well";
import DataSection from "../../comps/DataSection/DataSection";
import Heading from "@react/react-spectrum/Heading";
import formFields from "../config/formFields";
import { Translate } from "react-redux-i18n";
// // import geoPolData from '../config/geoPolData';
import SaveNExit from "./save_n_ext";

class CompanyInfo extends Component {
  constructor() {
    super();
    window.scrollTo(0, 0);
    this.state = {
      sectionValidation: {},
      formStateDetails: {},
    };
  }

  updateValidation = (name, value) => {
    let sectionValidation = this.state.sectionValidation;
    sectionValidation[name] = value;
    this.setState({ sectionValidation: sectionValidation });
  };

  componentDidMount() {
    // Check if this.props.formStates has proper data or else show an error message with the UI loaded and disable the "Proceed" & "Save &Exit" button
    this.setState(
      {
        formStateDetails: this.props.formStates,
      },
      () => {
        console.log("state updated !!! ==>");
      },
    );
  }

  render() {
    if (!this.props.isSaveAndExit) {
      this.props.onValidateChange(
        Object.values(this.state.sectionValidation).every(Boolean),
      );
      const formName = "registration";

      return (
        <div>
          <Grid>
            <GridRow>
              <GridColumn size={[12, 8, 6, 6]} offsetSize={[0, 2, 3, 3]}>
                <GridRow>
                  <GridColumn>
                    <Heading className="textBold" variant="pageTitle">
                      <Translate value="registration.tell_us" />
                    </Heading>
                    <p>
                      <Translate value="registration.comp_info_text" />
                    </p>
                  </GridColumn>
                </GridRow>
                <GridRow>
                  <GridColumn size={[12, 4, 4, 4]}>
                    <Heading variant="subtitle2">
                      <Translate value="registration.basic_comp_info" />
                    </Heading>
                  </GridColumn>
                </GridRow>
                <Well className="well">
                  <GridRow>
                    <GridColumn size={[12, 6, 6, 6]}>
                      <DataSection
                        formStates={this.props.formStates}
                        form={formName}
                        field={formFields.section3}
                        sectionName="section3"
                        updateValidation={this.updateValidation}
                      />
                    </GridColumn>
                    <GridColumn size={[12, 6, 6, 6]}>
                      <DataSection
                        formStates={this.props.formStates}
                        form={formName}
                        field={formFields.section4}
                        sectionName="section4"
                        updateValidation={this.updateValidation}
                      />
                    </GridColumn>
                  </GridRow>
                </Well>

                <GridRow>
                  <GridColumn size={[12, 4, 4, 4]}>
                    <Heading variant="subtitle2">
                      <Translate value="registration.location" />
                    </Heading>
                  </GridColumn>
                </GridRow>
                <Well className="well">
                  <GridRow>
                    <GridColumn size={[12, 6, 6, 6]}>
                      <DataSection
                        formStates={this.props.formStates}
                        form={formName}
                        field={formFields.section5}
                        sectionName="section5"
                        updateValidation={this.updateValidation}
                      />
                    </GridColumn>
                    <GridColumn size={[12, 6, 6, 6]}>
                      <DataSection
                        formStates={this.props.formStates}
                        form={formName}
                        field={formFields.section6}
                        sectionName="section6"
                        updateValidation={this.updateValidation}
                      />
                    </GridColumn>
                  </GridRow>
                </Well>
                <GridRow>
                  <GridColumn size={[12, 4, 4, 4]}>
                    <Heading variant="subtitle2">
                      <Translate value="registration.ONBContsInfo" />
                    </Heading>
                  </GridColumn>
                </GridRow>
                <Well className="well">
                  <GridRow>
                    <GridColumn size={[12, 6, 6, 6]}>
                      <DataSection
                        formStates={this.props.formStates}
                        form={formName}
                        field={formFields.section7}
                        sectionName="section7"
                        updateValidation={this.updateValidation}
                      />
                    </GridColumn>
                    <GridColumn size={[12, 6, 6, 6]}>
                      <DataSection
                        formStates={this.props.formStates}
                        form={formName}
                        field={formFields.section8}
                        sectionName="section8"
                        updateValidation={this.updateValidation}
                      />
                    </GridColumn>
                  </GridRow>
                </Well>
              </GridColumn>
            </GridRow>
          </Grid>
        </div>
      );
    } else {
      return <SaveNExit />;
    }
  }
}

CompanyInfo = reduxForm({
  form: "registration",
  destroyOnUnmount: false, //        <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(CompanyInfo);

function mapStateToProps(state) {
  return {
    formStates: getFormValues("registration")(state), // here 'form' is the name you have given your redux form
  };
}

export default connect(mapStateToProps)(CompanyInfo);
